import { FC, useEffect, useState } from 'react';
import { Box, Chip, TextField } from '@mui/material';

interface Props {
    onChange: (startDate: string, endDate: string) => void;
    defaultDays?: number;
}

const PRESETS = [
    { label: '7일', days: 7 },
    { label: '30일', days: 30 },
    { label: '90일', days: 90 },
] as const;

function formatDate(d: Date): string {
    return d.toISOString().slice(0, 10);
}

function daysAgo(n: number): string {
    const d = new Date();
    d.setDate(d.getDate() - n);
    return formatDate(d);
}

export const StatsDateFilter: FC<Props> = ({ onChange, defaultDays = 30 }) => {
    const [selectedDays, setSelectedDays] = useState<number | null>(defaultDays);
    const [startDate, setStartDate] = useState(daysAgo(defaultDays));
    const [endDate, setEndDate] = useState(formatDate(new Date()));

    useEffect(() => {
        onChange(startDate, endDate);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handlePreset = (days: number) => {
        const newStart = daysAgo(days);
        const newEnd = formatDate(new Date());
        setSelectedDays(days);
        setStartDate(newStart);
        setEndDate(newEnd);
        onChange(newStart, newEnd);
    };

    const handleStartChange = (value: string) => {
        setSelectedDays(null);
        setStartDate(value);
        if (value && endDate) onChange(value, endDate);
    };

    const handleEndChange = (value: string) => {
        setSelectedDays(null);
        setEndDate(value);
        if (startDate && value) onChange(startDate, value);
    };

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
            {PRESETS.map(({ label, days }) => (
                <Chip
                    key={days}
                    label={label}
                    size="small"
                    color={selectedDays === days ? 'primary' : 'default'}
                    variant={selectedDays === days ? 'filled' : 'outlined'}
                    onClick={() => handlePreset(days)}
                    sx={{ fontWeight: 500 }}
                />
            ))}
            <TextField
                type="date"
                size="small"
                label="시작일"
                value={startDate}
                onChange={(e) => handleStartChange(e.target.value)}
                slotProps={{ inputLabel: { shrink: true } }}
                sx={{ width: 160 }}
            />
            <TextField
                type="date"
                size="small"
                label="종료일"
                value={endDate}
                onChange={(e) => handleEndChange(e.target.value)}
                slotProps={{ inputLabel: { shrink: true } }}
                sx={{ width: 160 }}
            />
        </Box>
    );
};
